import {
    Box,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Tooltip,
    Typography,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import HistoryIcon from '@mui/icons-material/History';
import { ChatAssistantLogs } from '../../../shared/types/chat-assistant-logs';

export const ChatHistory = ({
    isOpenHistory,
    handleHistoryClose,
    lastChats,
    handleSelectConversation,
}: {
    isOpenHistory: boolean;
    handleHistoryClose: () => void;
    lastChats: ChatAssistantLogs[] | undefined;
    handleSelectConversation: (threadId: string) => void;
}) => {
    return isOpenHistory ? (
        <Box
            width="20%"
            display="flex"
            flexDirection="column"
            borderRadius="16px 0px 0px 16px"
            bgcolor="rgba(23, 39, 192, 0.1)"
            p={2}
            overflow="auto"
            borderRight="1px solid rgba(23, 39, 192, 0.2)"
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Typography color="#29235C" sx={{ fontWeight: 'bold' }}>
                    Últimas conversaciones
                </Typography>

                <IconButton onClick={handleHistoryClose}>
                    <ChevronLeftIcon sx={{ color: 'primary', fontSize: 24 }} />
                </IconButton>
            </Box>

            {lastChats?.length === 0 && (
                <Typography color={'#29235C'} sx={{ p: 2 }}>
                    No hay mensajes anteriores
                </Typography>
            )}

            <List>
                {lastChats?.map((chat) => (
                    <ListItemButton
                        key={chat.id}
                        onClick={() =>
                            handleSelectConversation(chat.threadId || '')
                        }
                    >
                        <ListItemText
                            primary={
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        variant="body1"
                                        noWrap
                                        sx={{
                                            flex: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {chat.message}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        sx={{ ml: 2, flexShrink: 0 }}
                                    >
                                        {new Date(
                                            chat.created_at as Date
                                        ).toLocaleDateString()}
                                    </Typography>
                                </Box>
                            }
                            sx={{ color: '#29235C' }}
                        />
                    </ListItemButton>
                ))}
            </List>
        </Box>
    ) : (
        <Box bgcolor="rgba(23, 39, 192, 0.16)" borderRadius="16px 16px 0px 0px">
            <Tooltip title="Ver conversaciones anteriores">
                <IconButton
                    onClick={handleHistoryClose}
                    sx={{ alignSelf: 'flex-start', pt: 2, pl: 2 }}
                >
                    <HistoryIcon sx={{ color: 'primary', fontSize: 28 }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};
